<template>
  <b-modal
    id="modal-message"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    hide-header-close
  >
  <!-- @hide="resetModal" -->
    <template #modal-header="{ close }">
      <h3 class="m-0">{{ newMessageData.id > 0 ? "修改" : "新增" }}評論</h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
          <b-row> 
            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_name"
              >
                <b-form-group
                  label="評論主題："
                  label-for="name"
                  label-cols-md="3"
                  class="required"
                >
                <b-form-input
                  v-model="newMessageData.name"
                  class=""
                ></b-form-input>
                <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="評論類別"
                rules="required"
              >
                <b-form-group
                  label="評論類別："
                  label-for="project_comment_type_id"
                  label-cols-md="3"
                >
                  <v-select
                    id="project_comment_type_id"
                    v-model="newMessageData.project_comment_type_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="commentTypeOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="Select Event"
                  >
                  </v-select>

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col> -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_remark"
              >
                <b-form-group
                  label="評論摘要："
                  label-for="remark"
                  label-cols-md="3"
                  class="required"
                >
                  <b-form-input
                    id="remark"
                    v-model="newMessageData.remark"
                    placeholder="輸入評論摘要"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <upload-file
                key="editMessage"
                custome_id="-inner-message"
                v-on:file-uploaded="onFileUploaded"
                file_delete_url="/project_comments/files"
                :props_previewImage="newMessageData.files"
              ></upload-file>
            </b-col>
            <!-- <b-col cols="12">
              <div class="d-flex mt-2 mb-1">
                <div class="d-inline-flex align-items-center">
                  <b-form-checkbox
                    v-model="newMessageData.toPDF"
                    id="exempt"
                    class="mr-0"
                    inline
                  />
                  <label class="mb-0" for="exempt" style="white-space: nowrap"
                    >製造成同一PDF
                    </label
                  >
                </div>
              </div>
            </b-col> -->
          </b-row>
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              class="mr-1"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
            >
              <font-awesome-icon
                class="mr-25"
                icon="fa-solid fa-circle-check"
              />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              class="mr-1"
              @click="hide"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormFile,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
import axiosIns from "@/libs/axios"
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormCheckbox,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    commentTypeOptions: {
      type: Array,
      required: true,
    },
    project_id:{},
    messageData: {}
  },
  data() {
    return {
      required,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-message");
    },
    resetModal(){
      this.newMessageData = {id:0}
    },
    onFileUploaded(file) {
      this.newMessageData.image_files = file;
    },
    onSubmit() {

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();

          formData.append("id", this.newMessageData.id);
          formData.append("project_id", this.newMessageData.project_id ? this.newMessageData.project_id : this.project_id);
          formData.append("name", this.newMessageData.name);
          formData.append("remark", this.newMessageData.remark);
          // formData.append("project_comment_type_id", this.newMessageData.project_comment_type_id);

          if (this.newMessageData.image_files && this.newMessageData.image_files.length > 0) {
            this.newMessageData.image_files.forEach((item) => {
              formData.append("image_files[]", item);
            });
          }

          // if (this.newMessageData.file) {
          //   if (this.newMessageData.file.size >= 2097152) {
          //     this.$toast({
          //       component: ToastificationContent,
          //       props: {
          //         title: "Error! Your Image size is larger then 2M",
          //         icon: "AlertTriangleIcon",
          //         variant: "danger",
          //       },
          //     });
          //     return false;
          //   } else {
          //     formData.append("file", this.newMessageData.file);
          //   }
          // }

          this.loading = true;
          axiosIns
            .post("/project_comments", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              this.$emit("refetch-data");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    deleteDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosIns
            .delete("project_comments/files", { params: {id} })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              const idx = this.newMessageData.files.findIndex(ele => ele.id === id)
              this.newMessageData.files.splice(idx,1)
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const newMessageData = ref({ id: 0 });

    const resetMessageRecordData = () => {
      newMessageData.value = JSON.parse(JSON.stringify({ id: 0 }));
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetMessageRecordData
    );

    watch(
      () => props.messageData,
      (newVal) => {
        newMessageData.value = { ...newVal };
      }
    );

    return {
      loading,
      newMessageData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
// #modal-message-message {
//   .full_input label {
//     width: calc(13% - 3px);
//   }
// }
</style>
